module.exports = __webpack_public_path__ + "static/pic06-612396c2acbfe3ad5da8478d04173122.png";